import { gql } from '@bayon/fetch';

export const validate = gql`
  query validate($filter: GEP_documento_em_elaboracao_filtro_type_input) {
    usuario_revisor_autorizado_alterar_documento(filter: $filter)
  }
`;
